/**
 * The radar's band colours - ONE map for the page and the development row. ⭐ D8's promise is that red
 * means on the development lane what it means on every other: a window that is closing.
 */
export const BAND_TONE: Record<string, string> = {
  urgent: 'border-red-200 bg-red-50 text-red-700',
  prime: 'border-amber-200 bg-amber-50 text-amber-700',
  early: 'border-sky-200 bg-sky-50 text-sky-700',
};
